<form [formGroup]="form" class="checklist-form" [class.empty]="isEmpty">
  <ul class="list-unstyled checklist d-flex flex-column gap-2 m-0">
    <li
      *ngFor="let formItem of arrItems.controls; let i = index"
      class="d-flex align-items-center justify-content-between gap-2 rounded checklist-item pl-2"
    >
      <app-form-switch
        [formControl]="formItem.get('status')"
        [inline]="true"
        [checkedValue]="1"
        [uncheckedValue]="0"
        (valueChange)="onChecklistChange(i, $event)"
      ></app-form-switch>
      <div
        editable="plaintext-only"
        class="px-2 py-1 flex-1"
        (keydown.enter)="onEnterChecklistItem($event)"
        [formControl]="formItem.get('name')"
      ></div>
      <div
        (click)="onRemove(i)"
        class="btn btn-sm btn-light-danger"
        i18n-matTooltip
        matTooltip="Remove the current checklist item"
      >
        <i class="cs-icon cs-icon-trash"></i>
      </div>
    </li>
  </ul>

  <div class="d-flex gap-2" *ngIf="isAdding">
    <div class="flex-1 mb-3 text-right">
      <mat-form-field2 class="mat-block" [showLabel]="false">
        <input
          matInput
          type="text"
          i18n-placeholder
          placeholder="Enter a checklist item and press Enter to add"
          [formControl]="taskCtrl"
          [matAutocomplete]="auto"
          (keydown.enter)="onEnterPressed()"
        />
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let t of checklists$ | async" [value]="t">
            {{ t }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field2>
      <button type="button" class="btn btn-light-danger btn-sm" *ngIf="!!arrItems.length" (click)="onClearChecklist()">
        <i class="cs-icon cs-icon-trash2"></i>
        <ng-container i18n>Delete All Checklist Entries</ng-container>
      </button>
    </div>
    <button class="btn btn-secondary-info" (click)="onEnterPressed()"><i class="cs-icon cs-icon-save2"></i></button>
  </div>
  <ng-container *ngIf="!isAdding">
    <app-empty-table *ngIf="isEmpty" [type]="tableType"> </app-empty-table>

    <div class="d-flex align-items-center justify-content-between gap-3" *ngIf="!!arrItems.length">
      <button type="button" class="btn btn-light-info btn-sm" (click)="isAdding = true">
        <i class="far fa-plus"></i>
        <ng-container i18n>Add Checklist</ng-container>
      </button>
      <button type="button" class="btn btn-light-danger btn-sm" (click)="onClearChecklist()">
        <i class="cs-icon cs-icon-trash2"></i>
        <ng-container i18n>Delete All Checklist Entries</ng-container>
      </button>
    </div>

    <div class="d-flex align-items-center justify-content-center gap-3" *ngIf="!arrItems.length">
      <button type="button" class="btn btn-secondary-info" (click)="isAdding = true">
        <i class="far fa-plus"></i>
        <ng-container i18n>Add Checklist</ng-container>
      </button>
    </div>
  </ng-container>
</form>
